import { StyleSheet } from 'react-native-web';
import { brand } from '../../../../../shared/colors-objects.js';

const styles = StyleSheet.create({
  iconContainer: {
    padding: 8,
    borderWidth: 1,
    borderRadius: 28,
    marginHorizontal: 2,
  },

  icon: {
    width: 28,
    height: 28,
  },

  selected: {
    backgroundColor: brand.lightTeal,
  },

  sportChevronContainer: {
    height: '100%',
    width: '2em',
    backgroundColor: 'white',
    zIndex: 2,

    // left/right is set dynamically in the component
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  sportChevronContainerLeft: {
    left: '-1px',
  },

  sportChevronContainerRight: {
    right: '-1px',
  },
});

export default styles;
